import React from "react";
import {Alert} from 'react-bootstrap';

const CErrorMessage = props => {
    const msg = props.msg?.details ? props.msg.details : props.msg;
    return msg ? (<>
        <Alert variant="warning">
            <span>{msg}</span>
        </Alert>
    </>) : null;
}

export default CErrorMessage;